export default () => Promise.resolve({})